"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _ToggleSwitchV = require("../ToggleSwitchV2");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ToggleSwitchComponent = function ToggleSwitchComponent(_ref) {
  var filterHidden = _ref.filterHidden,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement(_ToggleSwitchV.ToggleSwitchV2, {
    toolTipMessage: "Do not show hidden sources in the source area.",
    label: "Filter hidden sources",
    checked: filterHidden
    // Explicitly setting this to 'true' since it does NOT require permission for now
    ,
    enableFeature: true,
    labelCursor: "text",
    onClick: onClick,
    ddActionName: filterHidden ? 'Disable hidden sources' : 'Enable hidden sources'
  });
};
var SourceListFilter = function SourceListFilter(_ref2) {
  var props = (0, _extends2["default"])({}, ((0, _objectDestructuringEmpty2["default"])(_ref2), _ref2));
  return /*#__PURE__*/_react["default"].createElement(ToggleSwitchComponent, props);
};
var SourceListFilterPropTypes = {
  onClick: _propTypes.func,
  filterHidden: _propTypes.bool
};
ToggleSwitchComponent.propTypes = SourceListFilterPropTypes;
SourceListFilter.propTypes = SourceListFilterPropTypes;
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(SourceListFilter);